module.exports = __webpack_public_path__ + "img/I-BOS-1302-0.52518c6c.png";